const config = {
  type: 'html',
  moreEl: '[data-testimonials-load-more-button]',
  containerEl: '[data-testimonials-container]',
  params: {
    siteId: 113,
    limit: 6,
  },
  template: i => `<div class="testimonials__item">
    <div class="testimonials__item-inner">
      <div class="testimonials__item-id">Order #${i.customerId}</div>
      <div class="testimonials__item-body">"${i.body}"</div>
      <div class="testimonials__item-id testimonials__item-customer-id">Customer ID ${i.customerId}</div>
      <div class="testimonials__item-subj">said about ${i.orderTopic}</div>
    </div>
  </div>`,
  loader: true,
  callbackData: () => {
    const loader = document.querySelector('[data-testimonials-container] [data-loader]');

    if (loader) {
      loader.remove();
    }
  },
};

export default config;
